<template>
  <div class="relative flex gap-2">
    <input
      v-model="addressString"
      id="title-input"
      :placeholder="$t('editspot.address_placeholder')"
      class="h-full w-full border border-theme-secondary bg-transparent p-[10px] outline outline-0 focus:border-theme-primary text-xl"
      v-on:input="autoCompleteAdress"
      v-on:focusout="abortAdressInput"
    />
    <div
      class="h-full absolute right-2 top-0 loading loading-spinner"
      v-if="autocompleteLoading"
    ></div>
  </div>
  <div v-if="autocompleteError || error " class="error-msg text-theme-bad font-normal italic font-serif pt-1">
    {{ $t("error.generic") }}
  </div>
  <div class="relative">
    <ul
      v-if="addressList"
      class="bg-white absolute top-0 right-0 left-0 mt-0.5 rounded-md shadow-md z-30"
    >
      <li
        v-for="(address, index) of addressList.addressList"
        :value="index"
        @click="selectAddressFromList(index)"
        class="p-1 hover:bg-theme-primary cursor-pointer rounded-md"
      >
        {{ address.addressString }}
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">

import { FetchError } from 'ofetch';

const props = defineProps<{
  addressStringModel: string,
  selectAddress: (address: Address | undefined) => void,
  abortAddressInput?: () => void,
  error?: boolean
}>();

const baseUrl = useBaseUrl();
const address = ref<Address | undefined>();
const addressString = ref<string>(props.addressStringModel);
const addressList = ref<AddressList>();
const autocompleteLoading = ref(false);
const autocompleteError = ref<FetchError | undefined>();

defineExpose({
  addressString
});

const abortAdressInput = () => {
  if (props.abortAddressInput) {
    props.abortAddressInput();
  }
  setTimeout(() => {
    addressList.value = undefined;
    autocompleteLoading.value = false;
  }, 100);
};

const selectAddressFromList = (index: number) => {
  address.value = addressList.value?.addressList.at(index);
  addressString.value = address.value!.addressString;
  addressList.value = undefined;
  props.selectAddress(address.value);

};

const autoCompleteAdress = () => {
  let formData = new FormData();

  if (addressString.value != '') {
    formData.append('addressString', addressString.value);
    autocompleteLoading.value = true;
    return useApiAuth().post<AddressList>(baseUrl .value + 'address/autocomplete', formData)
      .then((response) => {
        if (response) {
          addressList.value = response;
        }
      }).catch((err) => {
        autocompleteError.value = err;
      }).finally(() => {
        autocompleteLoading.value = false;
      });
  }
};

</script>
